import { render, staticRenderFns } from "./AppCase.vue?vue&type=template&id=0e5acbce&scoped=true&"
var script = {}
import style0 from "./AppCase.vue?vue&type=style&index=0&id=0e5acbce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5acbce",
  null
  
)

export default component.exports